import React from "react";
import classNames from "classnames";
// import liquidspaceLogo from "Assets/logo/liquidspace-full.svg";
// import poweredByLiquidspaceLogo from "Assets/logo/poweredByLiquidSpace.svg";
import * as Icons from "Components/Icons";
import useMediaBreakpointDown from "Hooks/useMediaBreakpointDown";
import uikitcolors from "Styles/UIKit/uikit-colors.module.scss";

export interface HeaderLogoProps {
   branding?: LSCommon.BrandedJsModel;
   className?: string;
   isSuperUser?: boolean;
   isEnterpriseManagment?: boolean;
}

const HeaderLogo: React.FC<HeaderLogoProps> = ({ branding, className, isSuperUser, isEnterpriseManagment }) => {
   const isMobile = useMediaBreakpointDown("sm");

   return branding
      ? (
         <div className={classNames("header-logo-wrapper", { "text-truncate": !branding.logoUrl }, className)}>
            <a className={classNames("header-logo", { "text-truncate header-logo-text": !branding.logoUrl })} href={branding.url || undefined}>
               {
                  branding.logoUrl
                     ? <img src={branding.logoUrl} alt={branding.name || undefined} />
                     : branding.name
               }
            </a>
            {isSuperUser && isEnterpriseManagment && isMobile
               ? <></>
               : <>
                  <div className="header-logo-separator"></div>
                  <a className="header-logo" href="/" aria-label="LiquidSpace Home page">
                     <Icons.LiquidSpacePoweredByLogo color={uikitcolors["neutral-2"]} className="header-logo-lspwr" preserveAspectRatio="xMinYMid slice" />
                     {/* <img alt="LiquidSpace" src={poweredByLiquidspaceLogo} width="168" height="32" /> */}
                  </a>
               </>
            }            
         </div>
      )
      : (isSuperUser && isEnterpriseManagment && isMobile
            ? <></> : <div className={classNames("header-logo-wrapper", className)}>
            <a href="/" className="header-logo" aria-label="LiquidSpace Home page">
               <Icons.LiquidSpaceLogoFull color={uikitcolors["deep-sea"]} className="header-logo-ls" preserveAspectRatio="xMinYMid slice"/>
               {/* <img alt="LiquidSpace" src={liquidspaceLogo} width="169" height="32" /> */}
            </a>
         </div>
      );
}

export default HeaderLogo;